// src/office-hours.ts
var WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
function zonedClock(at, timezone) {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: timezone,
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23"
  }).formatToParts(at);
  const get = (type) => parts.find((p) => p.type === type)?.value ?? "";
  return {
    day: WEEKDAYS.indexOf(get("weekday")),
    minutes: Number(get("hour")) * 60 + Number(get("minute"))
  };
}
function toMinutes(clock) {
  const [h, m] = clock.split(":").map(Number);
  return (h ?? 0) * 60 + (m ?? 0);
}
function isWithinOfficeHours(hours, at = /* @__PURE__ */ new Date()) {
  if (!hours.enabled) return true;
  const { day, minutes } = zonedClock(at, hours.timezone);
  const previousDay = (day + 6) % 7;
  return hours.windows.some((w) => {
    const open = toMinutes(w.open);
    const close = toMinutes(w.close);
    if (open < close) return w.day === day && minutes >= open && minutes < close;
    return w.day === day && minutes >= open || w.day === previousDay && minutes < close;
  });
}

// src/constants.ts
var MAX_MESSAGE_LENGTH = 5e3;
var MAX_ATTACHMENTS_PER_MESSAGE = 5;
var MAX_ATTACHMENT_BYTES = 10 * 1024 * 1024;
var ALLOWED_ATTACHMENT_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
  "image/heic",
  "application/pdf"
];
var CLOSE_ACCESS_REVOKED = 4003;
var CLOSE_SESSION_REVOKED = 4401;

export {
  zonedClock,
  isWithinOfficeHours,
  MAX_MESSAGE_LENGTH,
  MAX_ATTACHMENTS_PER_MESSAGE,
  MAX_ATTACHMENT_BYTES,
  ALLOWED_ATTACHMENT_TYPES,
  CLOSE_ACCESS_REVOKED,
  CLOSE_SESSION_REVOKED
};
